import styled from 'styled-components'
import { Modal } from 'antd'
import { colors, device } from 'Styled/variables'

export const ModalContainer = styled(Modal)<{ modalHeaderGreen: boolean }>`
  .ant-modal-content {
    width: 600px;
    border-radius: 8px;

    .ant-modal-close {
      display: ${({ modalHeaderGreen }) =>
        modalHeaderGreen ? `flex` : `none`};
      align-items: center;
      justify-content: center;

      .ant-modal-close-x {
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${colors.white};
        opacity: 0.5;

        svg {
          width: 10px;
          height: 10px;
        }
      }
    }
    .ant-modal-header {
      padding: 16.5px 24px;
      border-radius: 8px 8px 0 0;
      background-color: ${({ modalHeaderGreen }) =>
        modalHeaderGreen ? colors.green : 'transparent'};
      border: ${({ modalHeaderGreen }) =>
        !modalHeaderGreen ? `none` : `border: 1px solid #f0f0f0`};

      .ant-modal-title {
        font-size: 18px;
        font-weight: 400;
        color: ${({ modalHeaderGreen }) =>
          modalHeaderGreen ? colors.white : colors.mainText};
      }
    }
    .ant-modal-body {
      position: relative;
      padding: ${({ modalHeaderGreen }) =>
        modalHeaderGreen ? `24px 95px` : `0 24px`};
      border-radius: 0 0 8px 8px;
    }
    .ant-modal-footer {
      display: none;
    }
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  height: 40px;
`

export const BackButton = styled.img`
  margin-right: 22px;
  width: 12px;
  height: 12px;
`

export const HeaderTitle = styled.h4`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const HeaderTitleAlt = styled(HeaderTitle)`
  font-size: 18px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const TimeLeft = styled.span<{ red: boolean }>`
  color: ${({ red }) => (red ? colors.messegesRed : `inherit`)};

  &::first-letter {
    color: inherit;
  }
`

export const MobileModalContainer = styled.div`
  position: relative;
  padding: 16px;
  background: ${colors.white};
  border-radius: 4px;
`

export const ModalTitle = styled.span<{ modalHeaderGreen?: boolean }>`
  font-size: 18px;
  font-weight: 400;
  color: ${({ modalHeaderGreen }) =>
    modalHeaderGreen ? colors.white : colors.mainText};
`

export const ReservedContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 216px;
  background: ${colors.white};

  @media ${device.mobileMax} {
    position: fixed;
    z-index: 999;
    padding: 0 24px;
    justify-content: center;
  }
`

export const ReservedText = styled.p`
  margin-top: 0;
  margin-bottom: 33px;
  font-size: 18px;
  color: ${colors.mainText};

  @media ${device.mobileMax} {
    text-align: center;
  }
`

export const ButtonsContainer = styled.div`
  padding: 30px 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${device.mobileMax} {
    position: absolute;
    bottom: 0;
    flex-direction: column;
  }
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9.5px 40px;
  height: 40px;
  font-size: 14px;
  border-radius: 27px;
  color: ${colors.white};
  background-color: ${({ disabled }) =>
    disabled ? colors.greyTextBlackBg : colors.green};
  border: 1px solid
    ${({ disabled }) => (disabled ? colors.greyTextBlackBg : colors.green)};
  white-space: nowrap;
`

export const ButtonSimple = styled.button<{ reserved?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  padding: 0;
  font-size: 14px;
  color: ${colors.mainText};
  background: transparent;
  border-bottom: 1px dashed ${colors.mainText};
  white-space: nowrap;

  @media ${device.mobileMax} {
    margin: ${({ reserved }) => (reserved ? `0 0 25.5px 0` : `16px 0 0 0`)};
  }
`
